import React, { useEffect, useState } from "react";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { useParams } from "react-router";
import NationalityDropdown from "../../UI/NationalityDropdown";

const BasicInfo = ({
  setCanContinue,
  setBirthdate,
  birthdate,
  setTel,
  tel,
  setAge,
  age,
  setMaritalStatus,
  maritalStatus,
  setGender,
  gender,
  setProfession,
  profession,
  setPersonalAddress,
  personalAddress,
}) => {
  const [error, setError] = useState("");

  // Function to handle date change with HTML5 date input
  const handleDateChange = (e) => {
    const date = e.target.value;
    setError("");
    setBirthdate(date);
  };

  useEffect(() => {
    // debugger;
    if (
      birthdate &&
      maritalStatus &&
      gender &&
      profession &&
      personalAddress &&
      tel &&
      error === ""
    ) {
      setCanContinue(true);
    } else {
      setCanContinue(false);
    }
  }, [birthdate, age, maritalStatus, gender, profession, personalAddress, tel]);

  useEffect(() => {
    setCanContinue(false);
  }, []);

  return (
    <div className="bg-white shadow-lg rounded-lg p-4 sm:p-6 md:p-8 max-w-4xl mx-auto">
      {/* Header Section */}
      <div className="mb-6">
        <h2 className="text-2xl sm:text-3xl font-bold mb-3 text-gray-800">
          Información Personal
        </h2>
        <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
          Completá tus datos personales para continuar con el registro.
        </p>
      </div>

      {/* Form Section */}
      <form className="flex flex-col space-y-4">
        {/* Phone Input */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Teléfono <span className="text-red-500">*</span>
          </label>
          <input
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-3 transition duration-150 ease-in-out"
            required
            type="tel"
            placeholder="Ej: 0981123456"
            onChange={(e) => setTel(e.target.value)}
            value={tel || ""}
          />
        </div>

        {/* Birthday Input - Using HTML5 date input */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            <span className="hidden sm:inline">Fecha de Nacimiento</span>
            <span className="sm:hidden">Nacimiento</span>
            <span className="text-red-500"> *</span>
          </label>
          <input
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-3 transition duration-150 ease-in-out [&::-webkit-calendar-picker-indicator]:opacity-100 [&::-webkit-calendar-picker-indicator]:cursor-pointer"
            required
            type="date"
            onChange={handleDateChange}
            value={birthdate || ""}
            max={new Date().toISOString().split("T")[0]}
            style={{
              WebkitAppearance: "none",
              MozAppearance: "textfield",
            }}
          />
          {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
        </div>

        {/* Gender Select */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Género <span className="text-red-500">*</span>
          </label>
          <select
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-3 transition duration-150 ease-in-out"
            required
            onChange={(e) => setGender(e.target.value)}
            value={gender || ""}
          >
            <option value="">Seleccioná tu género</option>
            <option value="Masculino">Masculino</option>
            <option value="Femenino">Femenino</option>
            <option value="Otro">Otro</option>
          </select>
        </div>

        {/* Marital Status Select */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Estado Civil <span className="text-red-500">*</span>
          </label>
          <select
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-3 transition duration-150 ease-in-out"
            required
            onChange={(e) => setMaritalStatus(e.target.value)}
            value={maritalStatus || ""}
          >
            <option value="">Seleccioná tu estado civil</option>
            <option value="Soltero/a">Soltero/a</option>
            <option value="Casado/a">Casado/a</option>
            <option value="Divorciado/a">Divorciado/a</option>
            <option value="Viudo/a">Viudo/a</option>
            <option value="Unión Libre">Unión Libre</option>
          </select>
        </div>

        {/* Profession Input */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Profesión <span className="text-red-500">*</span>
          </label>
          <input
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-3 transition duration-150 ease-in-out"
            required
            type="text"
            placeholder="Ej: Contador"
            onChange={(e) => setProfession(e.target.value)}
            value={profession || ""}
          />
        </div>

        {/* Address Input */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Dirección Personal <span className="text-red-500">*</span>
          </label>
          <input
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-3 transition duration-150 ease-in-out"
            required
            type="text"
            placeholder="Ej: Av. Mariscal López 1234"
            onChange={(e) => setPersonalAddress(e.target.value)}
            value={personalAddress || ""}
          />
        </div>
      </form>
    </div>
  );
};

export default BasicInfo;
